import { ApiClient } from "./apiClient";
import { env } from "../type/AppLimits";

const conf = require("../config/config.json")[env];
const COGNITO_ENDPOINT = `https://cognito-idp.${conf.COGNITO_REGION}.amazonaws.com/`;
const CLIENT_ID: string = conf.COGNITO_CLIENT_ID;

async function cognitoHttp(target: string, body: object): Promise<any> {
  const response = await fetch(COGNITO_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": `AWSCognitoIdentityProviderService.${target}`,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || err.__type || "Cognito error");
  }
  return response.json();
}

export const authApi = {
  signIn: (data: any) =>
    cognitoHttp("InitiateAuth", {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: CLIENT_ID,
      AuthParameters: {
        USERNAME: data.email,
        PASSWORD: data.password,
      },
    }),

  signOut: (accessToken: string) =>
    cognitoHttp("GlobalSignOut", { AccessToken: accessToken }),

  refreshToken: (token: string) =>
    cognitoHttp("InitiateAuth", {
      AuthFlow: "REFRESH_TOKEN_AUTH",
      ClientId: CLIENT_ID,
      AuthParameters: { REFRESH_TOKEN: token },
    }),

  forgotPassword: (data: any) =>
    cognitoHttp("ForgotPassword", {
      ClientId: CLIENT_ID,
      Username: data.email,
    }),

  confirmForgotPassword: (email: string, code: string, password: string) =>
    cognitoHttp("ConfirmForgotPassword", {
      ClientId: CLIENT_ID,
      Username: email,
      ConfirmationCode: code,
      Password: password,
    }),

  // These remain on the backend, unchanged:
  signUp: (data: object) =>
    ApiClient.post({ path: "user/add", body: data, auth: false }),

  resetPassword: (data: object) =>
    ApiClient.put({ path: "authorization", body: data, auth: false }),

  fetchTerms: () => ApiClient.get({ path: "terms", auth: false }),

  getUser: (id: number) => ApiClient.get({ path: "user/" + id }),
};
